import { batch } from 'react-redux';
import Role from 'resources/Role';
import Shift from 'resources/Shift';

import { removeAll as removeAllConflicts } from 'features/scheduleBuilder/slices/conflicts/slice';
import { actions as estimatedSalesActions } from 'features/scheduleBuilder/slices/estimatedSales/slice';
import { actions as eventQuotaActions } from 'features/scheduleBuilder/slices/eventQuotas/slice';
import { actions as eventActions } from 'features/scheduleBuilder/slices/events/slice';
import { actions as laborTargetsActions } from 'features/scheduleBuilder/slices/laborTargets/slice';
import { actions as scheduleAvailabilityActions } from 'features/scheduleBuilder/slices/scheduleAvailabilities/slice';
import { actions as shiftEventsActions } from 'features/scheduleBuilder/slices/shiftEvents/slice';
import { actions as shiftNotesQuotaActions } from 'features/scheduleBuilder/slices/shiftNotesQuotas/slice';
import { actions as timeOffActions } from 'features/scheduleBuilder/slices/timeOffs/slice';
import { actions as weatherForecastActions } from 'features/scheduleBuilder/slices/weatherForecast/slice';

import ClaimRequest from '../resources/ClaimRequest';
import RoleLaborTotals from '../resources/RoleLaborTotals';

const clearScheduleLegacy = () => dispatch => {
  batch(() => {
    dispatch(shiftEventsActions.removeAll());
    dispatch(estimatedSalesActions.removeAll());
    dispatch(laborTargetsActions.removeAll());
    dispatch(RoleLaborTotals.clearAllEntities());
    dispatch(scheduleAvailabilityActions.removeAll());
    dispatch(shiftNotesQuotaActions.removeAll());
    dispatch(Shift.clearAllEntities());
    dispatch(eventActions.removeAll());
    dispatch(eventQuotaActions.removeAll());
    dispatch(timeOffActions.removeAll());
    dispatch(removeAllConflicts());
    dispatch(ClaimRequest.clearAllEntities());
    dispatch(Role.clearAllEntities());
    dispatch(weatherForecastActions.clearAllEntities());
  });
};

export default clearScheduleLegacy;
